import { z } from 'zod';

export type AccountingReportRequestFilter = {
    date_year?: number,
    date_month?: number,
    brand_id?: number,
    models_ids?: number[],
    dealers_ids?: number[],
    vin?: string,
    selling_price?: [number, number],
};

export type AccountingReportDownloadErrors = {
    date_year?: string[],
    date_month?: string[],
    brand_id?: string[],
    models_ids?: string[],
    dealers_ids?: string[],
    vin?: string[],
    selling_price?: string[],
};

export const AccountingReportDownloadErrorsSchema = z.object({
    date_year: z.string().array().optional(),
    date_month: z.string().array().optional(),
    brands_ids: z.string().array().optional(),
    models_ids: z.string().array().optional(),
    dealers_ids: z.string().array().optional(),
    vin: z.string().array().optional(),
    selling_price: z.string().array().optional(),
});
